import { useState } from "react";
import { TACO0 } from "./TACO0";

export function TACOF () {
    const [text, setText] = useState<string>('');
    const [result, setResult] = useState<string>('');

    const handleChange = (event : any) => {
        setText(event.target.value);
    };

    const handleSubmit = (event : any) => {
        setResult('Sorry, there are no Taco Bongos in your area.');
    };

    return <div className='taco-box width-768 height-512 v-box padding-64'>
        <h1 className="text-taco-purp" style={{margin:0}}>Find Us!</h1>
        <p>Enter your Zip Code to find a Taco Bongo near you!</p>
        <form onSubmit={handleSubmit} className='h-box gap-4 cursor-none'>
            <input value={text} onChange={handleChange} />
            <input type="submit" value="Search!" className='og-button' />
        </form>
        <p>{ result }</p>
    </div>
}